/**
 * craate a div with the variable as color and get the true used color
 * @param variable 
 * @returns 
 */
export function getComputedColorVariable(variable :string){
  const colorFromCssPick = document.createElement('span')
  colorFromCssPick.style.color = "var("+variable+")";
  document.body.appendChild(colorFromCssPick)
  const result = getComputedStyle(colorFromCssPick).color;
  document.body.removeChild(colorFromCssPick);
  return new Color(result);
}

class Color{
  r:number;
  g:number;
  b:number;
  a:number = 255;
  constructor(string :string|{r:number,g:number,b:number,a?:number}){
    if(typeof string === 'string'){
      string = string.trim();
      const assign = (val :string,idx :number)=>{
        const asNumber = parseFloat(val);
        this[['r','g','b','a'][idx]] = idx===3?Math.round(asNumber*255):Math.round(asNumber);
      }
      const assignHex = (val :string,idx :number)=>{
        const asNumber = parseInt(val,16);
        this[['r','g','b','a'][idx]] = asNumber;
      }
      if(string.startsWith('rgba(')){
        string.substring(5,string.length-1).split(',').forEach(assign)
      }else if(string.startsWith('rgb(')){
        string.substring(4,string.length-1).split(',').forEach(assign)
      }else if(string.startsWith('#')){
        if(string.length===4){
          string.substring(1).split('').map(v=>v+v).forEach(assignHex)
        }else {
          assignHex(string.substring(1,3),0)
          assignHex(string.substring(3,5),1)
          assignHex(string.substring(5,7),2)
          if(string.length>7){
            assignHex(string.substring(7,9),3)
          }
        }
      }else{
        throw new Error('Not a color '+string)
      }
    }else{
      this.r = string.r
      this.g = string.g
      this.b = string.b
      this.a = string.a===undefined?255:string.a
      
    }
    
  }
  toString(){
    const hex2 = (v:number)=>{
      v = Math.round(v)
      if(v<16){
        return 0+v.toString(16)
      }
      return v.toString(16)
    }
    return '#'+hex2(this.r)+hex2(this.g)+hex2(this.b)+(this.a===255?'':hex2(this.a))
  }
  setOpacityPercent(a:number){
    return new Color({r:this.r,g:this.g,b:this.g,a:a*2.55})
  }
}